// components/ProductImage.jsx
import React, { useState, useEffect } from "react";
import { baseURL } from "../../include/api"; // 👈 Import baseURL

const ProductImage = ({ productId, products, fetchProductDetails, alt = "" }) => {
  const [imgSrc, setImgSrc] = useState("/placeholder-image.png");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const product = products[productId];
    
    if (product && product.mainImage) {
      // Construct full image URL with baseURL
      let imageUrl = product.mainImage;
      
      // If it's a relative path (doesn't start with http or https)
      if (!imageUrl.startsWith('http')) {
        // Ensure it starts with a slash
        if (!imageUrl.startsWith('/')) {
          imageUrl = '/' + imageUrl;
        }
        // Add baseURL
        imageUrl = baseURL + imageUrl;
      }
      
      setImgSrc(imageUrl);
      setLoading(false);
    } else {
      // Trigger fetch if not already done
      fetchProductDetails([productId]);
    }
  }, [productId, products, fetchProductDetails]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className="img-fluid rounded-8"
      style={{
        maxHeight: "120px",
        objectFit: "contain",
        opacity: loading ? 0.5 : 1,
        transition: "opacity 0.3s ease",
      }}
      onError={(e) => {
        e.target.onerror = null;
        setImgSrc("/placeholder-image.png");
        setLoading(false);
      }}
      onLoad={() => setLoading(false)}
      loading="lazy"
    />
  );
};

export default React.memo(ProductImage);